import React from 'react';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import GetAppIcon from '@material-ui/icons/GetApp';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import {
  ticketNumberState,
  startLoading,
  stopLoading,
} from '../../HomePage/ContentTabs/ContentTabsSlice';
import ApiService from '../../../services/ApiService';
import helpers from '../../AddAnomaly/FileUploader/Helpers';
import useStyles from './styles';

const FileSaver = require('file-saver');

export default function FileReader(props) {
  const { attachments, anomalyIndex } = props;
  const ticketNumber = useSelector(ticketNumberState);
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  function downloadFile(filename) {
    dispatch(startLoading());
    ApiService.getAttachment(ticketNumber, anomalyIndex, filename)
      .then((response) => {
        const blob = new Blob([helpers.base64toBlob(response.data)], {});
        FileSaver.saveAs(blob, filename);
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
        props.setOpenTechnicalErrorAlert(true);
        props.setTechnicalErrorMessage(
          t('A technical error occured while downloading file') +
            filename +
            t('file could not be retrieved'),
        );
      });
  }
  return (
    <Grid container spacing={1} className={classes.gridMargin}>
      <Grid item xs={12}>
        <FormLabel className={classes.formLabel}>
          {t('Uploaded files')}
        </FormLabel>
      </Grid>
      <Grid item xs={6}>
        <List>
          {attachments.map((attachment, attachmentIndex) => {
            const attachmentId = `attachment-${attachmentIndex}`;
            return (
              <ListItem key={attachmentId} divider className={classes.listItem}>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography className={classes.filename}>
                      {attachment.filename}
                    </Typography>
                  }
                />
                <ListItemIcon>
                  <GetAppIcon
                    className={classes.downloadButton}
                    onClick={() => downloadFile(attachment.filename)}
                  />
                </ListItemIcon>
              </ListItem>
            );
          })}
        </List>
      </Grid>
    </Grid>
  );
}
